var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showBreadcrumbs
    ? _c("v-breadcrumbs", {
        staticClass: "pa-0 category-breadcrumbs",
        attrs: { items: _vm.items },
        scopedSlots: _vm._u(
          [
            {
              key: "divider",
              fn: function () {
                return [_c("span", [_vm._v("/")])]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1953242856
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }